<div class="row page-titles">
  <div class="col-md-8 col-12 align-self-center">
    <ol class="breadcrumb mb-0 p-0 bg-transparent">
      <li class="breadcrumb-item"><a href="javascript:;" [routerLink]="['/home']">Início</a></li>
      <li class="breadcrumb-item" *ngFor="let item of breadcrumb">{{ item }}</li>
    </ol>
  </div>
</div>
